module.exports = __webpack_public_path__ + "img/step26_a_stand_power_attach_basket_with_velcro.6d437d38.png";